import _ from "lodash";
import {TFunction} from "i18next";

// ---------------------------------------------------------------------------------------------------------------------
export const enum TranslationContext {
    DEVICE_HISTORY_TYPE = "deviceHistoryType",
    DEVICE_HISTORY_JOB_ID = "deviceHistoryJobID",
    DEVICE_HISTORY_SEVERITY = "deviceHistorySeverity",
    EETS_DEVICE_HISTORY_TYPE = "eetsDeviceHistoryType",
    ENVIRONMENT = "environment",
    FIRMWARE_UPDATE_STATUS = "firmwareUpdateStatus",
    FIRMWARE_STATE = "firmwareState",
    COUNTRY = "country",
    LANGUAGE = "language",
    PRODUCTIVE_STAGE = "productiveStage",
    ORDER_STATUS = "orderStatus",
    TERMINATION_STATUS = "terminationStatus",
    TERMINATION_MAIL_TYPE = "terminationMailType",
    TERMINATION_ITEM_RETURN_STATUS = "terminationItemReturnStatus",
    TERMINATION_ITEM_TEST_RESULT = "terminationItemTestResult",
    SHIPMENT_STATUS = "shipmentStatus",
    VALIDATION = "validation",
    EETS_STATUS = "eetsStatus",
    ASSET_TYPE = "assetType",
    DEVICE_JOB_SOURCE = "deviceJobSource",
    DEVICE_JOB_TYPE = "deviceJobType",
    DEVICE_JOB_STATUS = "deviceJobStatus",
    DEVICE_JOB_PRIORITY = "deviceJobPriority",
}

interface GetTranslationKeyProps {
    context: TranslationContext;
    value?: string | null;
}

export const getTranslationKey = ({context, value}: GetTranslationKeyProps): string => {
    if (_.isEmpty(value) || _.isNil(value)) {
        return "";
    }
    return `${context}_${_.camelCase(value)}`;
};

// ---------------------------------------------------------------------------------------------------------------------

interface GetTranslationProps extends GetTranslationKeyProps {
    t: TFunction;
}

export const getTranslation = ({context, value, t}: GetTranslationProps): string => {
    return t(getTranslationKey({context, value}));
};
